import { render, staticRenderFns } from "./BindKeyValueEditor.vue?vue&type=template&id=959bd88e&scoped=true&"
import script from "./BindKeyValueEditor.vue?vue&type=script&lang=js&"
export * from "./BindKeyValueEditor.vue?vue&type=script&lang=js&"
import style0 from "./BindKeyValueEditor.vue?vue&type=style&index=0&id=959bd88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959bd88e",
  null
  
)

export default component.exports